/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var DepEntityLocationView = require('../views/DepEntityLocationView');
var GetEntityLocations = require('../services/GetEntityLocationsByEntity');

module.exports = {
  channel: 'dp',

  event: 'build:entity-location-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: buildEntityLocationView(data)
    });
  }
};

function buildEntityLocationView(data) {
  var deferred = $.Deferred();

  GetEntityLocations(data.entityId)
    .done(function(locations) {
      deferred.resolve(
        new DepEntityLocationView({
          model: new Backbone.Model({
            entityId: data.entityId,
            entityCategoryId: data.entityCategoryId,
            entityTypeId: data.entityTypeId
          }),
          collection: new PageableCollection(locations, { pageSize: 25 })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
